module.exports = __webpack_public_path__ + "static/img/white-logo.cc30fd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-logo.svg
// module id = 3266
// module chunks = 1